<template>
    <div>
        <div class="row">
            <div class="col-md-6">
                <Field
                    :name="fieldName('phone')"
                    v-model="value.phone"
                    type="phone"
                    label="Téléphone"
                    :errors="errors"
                />
            </div>
            <div class="col-md-6">
                <Field
                    :name="fieldName('mobile_phone')"
                    v-model="value.mobile_phone"
                    label="Téléphone portable"
                    type="phone"
                    :errors="errors"
                />
            </div>
        </div>
        <div class="text-muted small">
            Veuillez indiquer au moins un n° de téléphone
        </div>
    </div>
</template>

<script>
    import Field from "../Field";

    export default {
        components: {
            Field,
        },
        props: {
            value: Object,
            errors: Object,
            name: {
                type: String,
                default: 'address',
            },
        },
        methods: {
            fieldName(name) {
                return `${this.name}.${name}`;
            },
        }
    }
</script>
